import { render, staticRenderFns } from "./BlockedPhrasesTable.vue?vue&type=template&id=5c18b8a7"
import script from "./BlockedPhrasesTable.vue?vue&type=script&lang=js"
export * from "./BlockedPhrasesTable.vue?vue&type=script&lang=js"
import style0 from "./BlockedPhrasesTable.vue?vue&type=style&index=0&id=5c18b8a7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports